'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const DiscountPrice = renderWithRef('DiscountPrice', null, (o, t)=>{
    let { children: s } = o;
    return jsx(RenderComp, {
        root: "span",
        forwardedRef: t,
        classNames: new Set([
            'swan-discount-price'
        ]),
        props: o,
        children: s
    });
});

export { DiscountPrice };
